import type { UiCommandBusV2, UiSnapshotV2 } from "@/ui/runtime/contracts/manager-ui-v2";
import { Button } from "@/ui/foundation/primitives/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui/foundation/primitives/card";
import { formatFriendlyDate } from "@/ui/components/manager/manager-ui-helpers";

interface DaySummaryOverlayProps {
    snapshot: UiSnapshotV2;
    commands: UiCommandBusV2;
}

export function DaySummaryOverlay({ snapshot, commands }: DaySummaryOverlayProps) {
    if (snapshot.activeOverlayRoute !== "/manager/day-summary" || !snapshot.routes.daySummary.visible) {
        return null;
    }

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4">
            <Card className="w-full max-w-3xl">
                <CardHeader>
                    <CardDescription>{formatFriendlyDate(snapshot.routes.daySummary.date)}</CardDescription>
                    <CardTitle>{snapshot.routes.daySummary.headline}</CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-4">
                    <div className="text-sm text-muted-foreground">{snapshot.routes.daySummary.progress}</div>
                    <div className="grid gap-4 md:grid-cols-2">
                        <div>
                            <div className="mb-2 text-sm font-medium">Highlights</div>
                            <div className="space-y-1 text-sm text-muted-foreground">
                                {snapshot.routes.daySummary.highlights.map((item) => (
                                    <div key={item}>{item}</div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <div className="mb-2 text-sm font-medium">Fixtures</div>
                            <div className="space-y-1 text-sm text-muted-foreground">
                                {snapshot.routes.daySummary.fixtures.map((item) => (
                                    <div key={item}>{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <Button onClick={() => void commands.daySummaryContinue()}>Continue</Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
